import { getFilterDate, getOneMonthFilterDate } from '@/utils/helper';
import { GeneralFilterType, IBranchListItem } from '@/utils/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const dateInitialize = getFilterDate();
const oneMonthInitialize = getOneMonthFilterDate();

const initialFilterState: GeneralFilterType = {
  organization_id: '',
  branch_id: 'all',
  agent: 'all',
  agentMultiple: [],
  assetMultiple: [],
  reengaged: '',
  region_id: null,
  date_range: dateInitialize,
  month_date_range: oneMonthInitialize,
  branchesExist: true,
  branchCreated: false,
  billing_branch_id: 'all',
  branches: [],
  selectedTeamMembers: [],
  selectedCampaign: '',
  selectedClientTeam: '',
  hubspotCompanyIds: [],
  activeHubspotCompanyId: '',
};

const generalFilterReducer = createSlice({
  name: 'generalFilter',
  initialState: initialFilterState,
  reducers: {
    setOrganizationId: (state, action: PayloadAction<string>) => {
      state.organization_id = action.payload;
    },
    setBranchId: (state, action: PayloadAction<string>) => {
      state.branch_id = action.payload;
      state.region_id = '';
    },
    setRegionId: (state, action: PayloadAction<string>) => {
      state.region_id = action.payload;
      state.branch_id = '';
    },
    setAgents: (state, action: PayloadAction<string>) => {
      state.agent = action.payload;
    },
    setMultipleAgents: (state, action: PayloadAction<string[]>) => {
      state.agentMultiple = action.payload;
    },
    setMultipleAssets: (state, action: PayloadAction<string[]>) => {
      state.assetMultiple = action.payload;
    },
    setDateRange: (state, action: PayloadAction<string | undefined>) => {
      state.date_range = action.payload;
      state.month_date_range = action.payload;
    },
    setBranchesExist: (state, action: PayloadAction<boolean>) => {
      state.branchesExist = action.payload;
    },
    setBranchCreated: (state, action: PayloadAction<boolean>) => {
      state.branchCreated = action.payload;
    },
    setBillingBranchId: (state, action: PayloadAction<string>) => {
      state.billing_branch_id = action.payload;
    },
    setBranchList: (state, action: PayloadAction<IBranchListItem[] | []>) => {
      state.branches = action.payload;
    },
    setSelectedTeamMembers: (state, action: PayloadAction<any[]>) => {
      state.selectedTeamMembers = action.payload;
    },
    setReengaged: (state, action: PayloadAction<string[] | ''>) => {
      state.reengaged = action.payload;
    },
    setCampaign: (state, action: PayloadAction<string>) => {
      state.selectedCampaign = action.payload;
    },
    setSelectedClientTeam: (state, action: PayloadAction<string>) => {
      state.selectedClientTeam = action.payload;
    },
    setHubspotCompanyIds: (state, action: PayloadAction<string[]>) => {
      state.hubspotCompanyIds = action.payload;
      state.activeHubspotCompanyId = action.payload[0] ?? '';
    },
    setActiveHubspotCompanyId: (state, action: PayloadAction<string>) => {
      state.activeHubspotCompanyId = action.payload;
    },
  },
});

export const {
  setOrganizationId,
  setBranchId,
  setAgents,
  setMultipleAgents,
  setDateRange,
  setRegionId,
  setBranchesExist,
  setBranchCreated,
  setBillingBranchId,
  setBranchList,
  setMultipleAssets,
  setSelectedTeamMembers,
  setReengaged,
  setSelectedClientTeam,
  setCampaign,
  setHubspotCompanyIds,
  setActiveHubspotCompanyId,
} = generalFilterReducer.actions;

export default generalFilterReducer.reducer;
